<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="box-content">
      <div class="flex-2xs mb-3 justify-between">
          <div class="flex-2xs justify-end">
              <div class="pr-3-2xs pb-1 pb-0-2xs">
                  <select class="form-control" v-model="training_course_filter">
                      <option value="" v-if="training_course_filter === ''">Choose Course ...</option>
                      <option value="" v-else> Clear Filter</option>
                      <option v-for="course in training_courses" :value="course.id">
                        {{ course.title }}
                      </option>
                  </select>
              </div>
          </div>
      </div>
      <template v-if="!loading && total_count > 0">
          <table class="table_list">
          <thead>
          <tr>
            <th>Course Title</th>
            <th>Course Type</th>
            <th>User Name</th>
            <th>Company Name</th>
            <th>Email</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(booking, index) in bookings">
            <td>
              <a :href="`/commercial/training/${booking.commercial_training_course.id}`">{{ booking.commercial_training_course.title }}</a>
            </td>
            <td>
              {{ booking.commercial_training_course.commercial_training_course_type.label }}
            </td>
            <td>
              {{ booking.user.name }}
            </td>
            <td>
              {{ booking.user.company.name }}
            </td>
            <td>
              {{ booking.user.email }}
            </td>
            <td class="td_delete">
                <a @click="deleteBooking(booking.id)" class="txt-danger cursor-pointer">
                    <i class="fa fa-trash"></i>
                </a>
            </td>
          </tr>
          </tbody>
        </table>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong>
          No Results Found
        </strong>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.loadBookings();
  },
  props: [
      'logged_in_user',
      'training_courses',
  ],
  data() {
    return {
      bookings: [],
      current_page: 1,
      training_course_filter: '',
      total_count: 0,
      total_pages: 0,
      limit: 20,
      loading: true,
    }
  },
  methods: {
    loadBookings: _.debounce(function () {
      axios.post('/commercial/training/loadBookings', {
        page_number: this.current_page,
        training_course_filter: this.training_course_filter,
        limit: this.limit,
      }).then((response) => {
        this.bookings = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
      });
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.loadBookings();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.loadBookings();
    },
    deleteBooking(booking_id) {
      Swal.fire({
        title: 'Are you sure you want to cancel this booking?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/deleteBooking', {
            booking_id: booking_id,
          }).then((response) => {
            this.current_page = 1;
            this.loadBookings();
            Swal.fire({
              title: 'Booking Deleted',
              icon: 'success',
            });
          });
        }
      });
    },
  },
  watch: {
    training_course_filter() {
      this.current_page = 1;
      this.loadBookings();
    },
  },
};
</script>
